import React from 'react';

export const DeleteSpinner: React.FC<React.PropsWithChildren<unknown>> = () => (
  <div className="text-center pb-2 pe-1">
    <div
      className="spinner-border spinner-border-sm text-muted"
      role="status"></div>
  </div>
);
